import { useCallback, useMemo, useSyncExternalStore } from "react"
import { COMPACT_GRID_MAX_WIDTH } from "../constants"

const NEVER_CHANGES = () => () => undefined

function createWidthSubscriber(container: HTMLElement | null) {
  if (!container || typeof ResizeObserver === "undefined") return NEVER_CHANGES
  return (onChange: () => void) => {
    const observer = new ResizeObserver(onChange)
    observer.observe(container)
    return () => observer.disconnect()
  }
}

export function useIsCompactGrid(container: HTMLElement | null): boolean {
  const subscribeToWidth = useMemo(() => createWidthSubscriber(container), [container])
  const getIsCompact = useCallback(
    () => container !== null && container.getBoundingClientRect().width < COMPACT_GRID_MAX_WIDTH,
    [container],
  )

  return useSyncExternalStore(subscribeToWidth, getIsCompact)
}
